export default __webpack_public_path__ + "static/media/mn.7641b4d6.svg";